export const educationData = [
  {
    id: 0,
    name: "Technical School Kikinda",
    department: "Computer Engineering Technology",
    date: "2010 - 2014",
    place: "In Kikinda",
  },
  {
    id: 1,
    name: "Technical Faculty 'Mihajlo Pupin' Zrenjanin",
    department: "Management of Information Technology",
    date: "2014 - 2020",
    place: "In Zrenjanin",
  },
];
